import { render, staticRenderFns } from "./NewProjectFilters.vue?vue&type=template&id=78a2b4a0&"
import script from "./NewProjectFilters.vue?vue&type=script&lang=ts&"
export * from "./NewProjectFilters.vue?vue&type=script&lang=ts&"
import style0 from "./NewProjectFilters.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NewProjectFilters.vue"
export default component.exports